exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes dialogue{0%{text-shadow:-2px 2px 2px hsla(0,0%,100%,.5)}50%{text-shadow:2px 2px 2px hsla(0,0%,100%,.5)}to{text-shadow:-2px 2px 2px hsla(0,0%,100%,.5)}}.dialogue-en,.dialogue-jp{margin:24px 24px 0;text-shadow:2px 2px 2px hsla(0,0%,100%,.5);animation-name:dialogue;animation-iteration-count:infinite;animation-duration:5s}.dialogue-jp{font-size:28px}@media screen and (max-width:900px){.dialogue-jp{font-size:22px}}@media screen and (max-width:600px){.dialogue-jp{font-size:16px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/Dialogue/styles.sass
// module id = 114
// module chunks = 0